/**
 * CTA (Call To Action) Module
 * Handles CTA button interactions
 */

import { $, on, smoothScroll, getOffsetTop } from '../utils/dom.js';
import { CONFIG, SELECTORS } from '../config/constants.js';

export class CTAButtons {
    constructor() {
        this.primaryButton = $(SELECTORS.CTA_PRIMARY);
        this.secondaryButton = $(SELECTORS.CTA_SECONDARY);
        this.init();
    }

    init() {
        this.setupPrimaryButton();
        this.setupSecondaryButton();
    }

    /**
     * Setup primary CTA button (Add to Chrome)
     */
    setupPrimaryButton() {
        if (!this.primaryButton) return;

        on(this.primaryButton, 'click', () => {
            if (CONFIG.CHROME_STORE_URL !== '#') {
                window.open(CONFIG.CHROME_STORE_URL, '_blank');
            } else {
                alert(`${CONFIG.EXTENSION_NAME} coming soon! Add your Chrome Web Store URL to config/constants.js`);
            }
        });
    }

    /**
     * Setup secondary CTA button (Watch Demo)
     */
    setupSecondaryButton() {
        if (!this.secondaryButton) return;

        on(this.secondaryButton, 'click', () => {
            const demoSection = $(SELECTORS.DEMO_SECTION);
            if (demoSection) {
                const navbar = $(SELECTORS.NAVBAR);
                const navbarHeight = navbar ? navbar.offsetHeight : 0;
                const targetPosition = getOffsetTop(demoSection) - navbarHeight;
                smoothScroll(targetPosition);
            }
        });
    }
}
